export enum MigrationStatus {
  queued = "queued",
  requeued = "requeued",
  initialize = "initializing migration",
  reject = "rejecting migration",
  metadata = "metadata",
  fixed = "fixed",
  migrating = "migration in progress",
  staged = "staged",
  post_processing = "post processing",
  migrated = "migration complete",
  migrated_post_processing_failed = "migration complete - post processing failed",
  exception = "exception",
  fk_exception = "missing related entity",
  double_migrated = "already migrated",
  in_progress = "in_progress",
  //----- this is a status for empty value received
  unknown = "unknown",
}

export enum MigrationPostProcessingStatus {
  pending = "pending",
  in_progress = "in_progress",
  completed = "completed",
  failed = "failed",
}

export enum MigrationSteps {
  CopyMetadata = "copy_metadata",
  /// add the rest when needed
}

export enum MigrationDbTables {
  STUDY = "study",
  USER = "user",
  ORGANIZATION = "organization",
  ORGANIZATION_STUDY = "organization_study",
  CONTACT = "contact",
  PRINCIPAL_INVESTIGATOR = "principal_investigator",
  SITE = "site",
  STUDY_CONTACT = "study_contact",
  ADDRESS = "address",
  ADDRESS_ENTITY = "address_entity",
  WORKSPACE = "workspace",
  FACILITY = "facility",
  FACILITY_LOCATION_SUBMISSION = "facility_location_submission",
  SITE_FACILITY = "site_facility",
  DOCUMENT_TYPE = "document_type",
  ORGANIZATION_TYPE = "organization_type",
  DOCUMENT = "document",
  WORKSPACE_REVIEW = "workspace_review",
  REVIEW_ENTITY = "review_entity",
  REVIEW_HOLD = "review_hold",
}

export enum ServerErrorCodes {
  accessDeny = 403,
  notFound = 404,
  unauthorized = 401,
  goneClient = 410,
  internalServer = 500,
  businessLayerError = 400,
}

export enum PlaceHolderName {
  ERM_VERSION = "erm_version",
  DM_VERSION = "dm_version",
  ENABLE_REMIGRATIONS = "enable_remigrations",
  ENABLE_SITES_REMIGRATIONS = "enable_sites_remigrations",
  CUTOFF_DATE='cutoff_date',
}

export const UiEvents = [
  "mousemove",
  "mousedown",
  "mouseup",
  "click",
  "dblclick",
  "wheel",
  "scroll",
  "keydown",
  "keyup",
  "touchstart",
  "touchmove",
  "touchend",
  "input",
  "focus",
];
